'use strict';

/**
 * Updates tile images based on how many images are available
 * @param {jQuery} $swatch - The swatch element
 * @param {jQuery} $tile - The parent tile element
 */
function updateTileImages($swatch, $tile) {
    var newCardClass = $swatch.data('imgback') !== '' ? '.front-card' : '.default-card';

    if ($tile.find(newCardClass).length === 0) {
        var newClassIsDefault = newCardClass === '.default-card';
        $tile.find('.image-container').toggleClass('no-hover', newClassIsDefault);
        $tile.find('.back-card').toggleClass('d-none', newClassIsDefault);
        var classToRemove = newClassIsDefault ? 'front-card' : 'default-card';
        $tile.find('.' + classToRemove).removeClass(classToRemove).addClass(newCardClass.slice(1));
    }

    $tile.find(newCardClass).attr({
        src: $swatch.data('imgfront'),
        alt: $swatch.data('imgfrontalt'),
        title: $swatch.data('imgfronttitle')
    });

    if ($swatch.data('imgback') !== '') {
        if ($tile.find('.back-card').length === 0) {
            var $backCardWrapper = $('<a></a>').attr({
                href: $tile.find('.default-card').closest('a').attr('href'),
                'class': 'tile-link'
            });
            var $backCard = $('<img/>').attr({
                'class': 'tile-image back-card'
            });
            $tile.find('.image-container').append($backCardWrapper.html($backCard));
        }

        $tile.find('.back-card').attr({
            src: $swatch.data('imgback'),
            alt: $swatch.data('imgbackalt'),
            title: $swatch.data('imgbacktitle')
        });
    }
}

/**
 * Fetches variant data and updates tile based on response
 */
function selectVariation() {
    $(document).on('click', '.product-tile .swatch-item.swatch-circle.color-value', function () {
        var $swatch = $(this).find('.swatch.swatch-circle');

        if ($swatch.hasClass('selected') || $swatch.data('imgfront') === '') {
            return;
        }

        var $tile = $swatch.closest('.product-tile');
        var $prevSelectedSwatch = $tile.find('.selected');
        $prevSelectedSwatch.removeClass('selected');
        $swatch.addClass('selected');

        updateTileImages($swatch, $tile);

        $tile.find('.tile-link').attr({
            href: $swatch.data('url')
        });
    });
}

module.exports = {
    selectVariation: selectVariation
};